import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=15cdf5d6&scoped=true"
import script from "./NavTab.vue?vue&type=script&lang=js"
export * from "./NavTab.vue?vue&type=script&lang=js"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=15cdf5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cdf5d6",
  null
  
)

export default component.exports